<template>
  <div class="sp-date-field-shortcuts">
    <h4 class="sp-date-field-shortcuts__title">{{ t("date_range_shortcuts") }}</h4>
    <sp-button
      v-for="shortcut in shortcuts"
      :key="shortcut.key"
      variant="appearance-link"
      :data-shortcut="shortcut.key"
      @click="emit('select', shortcut)"
      >{{ shortcut.label }}</sp-button
    >
  </div>
</template>

<script setup>
import { computed } from "vue";
import { t } from "#ce/shared/forms-i18n";
import { rangeShortcuts } from "#ce/components/SpDateField/range-shortcuts";

const emit = defineEmits(["select"]);
const shortcuts = computed(() => rangeShortcuts(new Date()).map(withLabel));

function withLabel(shortcut) {
  return { ...shortcut, label: t(`date_range_${shortcut.key}`) };
}
</script>

<style lang="scss">
:host {
  --date-field-host-shortcut-text-decoration: var(--sp-comp-button-appearance-link-text-decoration);
  --date-field-host-shortcut-font-size: var(--sp-comp-button-font-size);
  --date-field-host-shortcut-line-height: var(--sp-comp-button-line-height);
}

// A flex host has no line box of its own, so a link is as tall as its text.
.sp-date-field-shortcuts sp-button {
  display: flex;

  --sp-comp-button-appearance-link-text-decoration: var(
    --sp-comp-date-field-shortcut-text-decoration,
    var(--date-field-host-shortcut-text-decoration)
  );
  --sp-comp-button-font-size: var(--sp-comp-date-field-shortcut-font-size, var(--date-field-host-shortcut-font-size));
  --sp-comp-button-line-height: var(
    --sp-comp-date-field-shortcut-line-height,
    var(--date-field-host-shortcut-line-height)
  );
}

.sp-date-field-shortcuts {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--sp-comp-date-field-shortcuts-item-gap, var(--sp-ref-scale-8));
}

.sp-date-field-shortcuts__title {
  display: flex;
  align-items: center;
  min-height: var(--sp-comp-date-field-shortcuts-title-min-height, auto);
  margin: 0 0
    var(
      --sp-comp-date-field-shortcuts-title-margin-bottom,
      var(--sp-comp-date-field-shortcuts-item-gap, var(--sp-ref-scale-8))
    );
  color: var(--sp-comp-date-field-shortcuts-title-color, inherit);
  font: var(--sp-sys-typescale-small-bold-short);
  font-size: var(--sp-comp-date-field-shortcuts-title-font-size, var(--sp-sys-typescale-small-font-size));
  font-weight: var(--sp-comp-date-field-shortcuts-title-font-weight, var(--sp-sys-typescale-small-bold-font-weight));
  text-transform: uppercase;
}
</style>
